import { Conversation, fetchChatHistoryInit, historyList } from "../api";
import { Action, AppState } from "./AppProvider";

// Define the reducer function
export const appStateReducer = (state: AppState, action: Action): AppState => {
  switch (action.type) {
    case "SET_FETCHING_MESSAGES":
      return { ...state, isFetchingMessages: action.payload };
    case "SET_SUBCATEGORY":
      return { ...state, selectedSubCategory: action.payload };

    case "SELECT_MODEL":
      return {
        ...state,
        selectedModel: action.payload,
        selectedAI: action.payload,
        selectedApp: null,
      };

    case "SELECT_APP":
      return {
        ...state,
        selectedApp: action.payload,
        selectedAI: action.payload,
        selectedModel: null,
      };

    case "FILTERED_CHAT_HISTORY_BY_MODEL":
      return {
        ...state,
        filteredChatHistoryByModel: action.payload,
      };

    case "RESET_MODEL":
      return { ...state, selectedModel: null };

    case "RESET_APP":
      return { ...state, selectedApp: null };

    case "SET_FILTERED_RESULTS":
      return { ...state, filteredResults: action.payload };
    case "SET_MODEL_CATEGORY":
      return { ...state, modelCategory: action.payload };

    case "SET_APP_CATEGORY":
      return { ...state, appCategory: action.payload };

    case "SET_MODEL_DETAILS":
      return { ...state, modelDetails: action.payload };

    case "PRIVACY_FOLLOWUP":
      return { ...state, PrivacyFollowups: action.payload };
    case "SUBCATAGORYBUTTON":
      return { ...state, SubCatagorybutton: action.payload };

    case "SET_CURRENT_QUESTION":
      return { ...state, currentQuestion: action.payload };

    case "ENTERED_QUESTION":
      return { ...state, enteredQuestion: action.payload };
    case "CONVERSATION_ID":
      return { ...state, converId: action.payload };

    case "SET_TEXTAREA_FOCUS":
      return { ...state, isTextAreaFocused: action.payload };
    case "LIVESEARCh__ACTIVE":
      return { ...state, isLiveSeachActive: action.payload };

    case "SET_DEFAULT_MODEL":
      return {
        ...state,
        defaultModel: action.payload,
      };
    case "TOGGLE_CHAT_HISTORY":
      return {
        ...state,
        isChatHistoryOpen: !state.isChatHistoryOpen,
        isPromtPanelOpen: false,
      };
    case "TOGGLE_PROMT_PANEL":
      return {
        ...state,
        isPromtPanelOpen: !state.isPromtPanelOpen,
        isChatHistoryOpen: false,
      };
    case "CLEAR_CHAT_HISTORY":
      return { ...state, clearChatHistory: action.payload };
    case "SEND_TRYIT_PROMPT":
      return { ...state, tryitPrompt: action.payload };
    case "DROPDOWN_ITEM":
      return { ...state, selectedAI: action.payload };
    case "SUBDROPDOWN_ITEM":
      return { ...state, subselectedAI: action.payload };
    case "REGENRATE_VALUE":
      return { ...state, regenrateValue: action.payload };
    case "UPDATE_CURRENT_CHAT":
      return { ...state, currentChat: action.payload };
    case "SINGLE_UPDATE_CURRENT_CHAT":
      return { ...state, singleCurrentChat: action.payload };
    case "UPDATE_CHAT_HISTORY_LOADING_STATE":
      return { ...state, chatHistoryLoadingState: action.payload };
    case "UPDATE_CHAT_HISTORY":
      if (!state.chatHistory || !state.currentChat) {
        return state;
      }
      let conversationIndex = state.chatHistory.findIndex(
        (conv) => conv.id === action.payload.id
      );
      if (conversationIndex !== -1) {
        let updatedChatHistory = [...state.chatHistory];
        updatedChatHistory[conversationIndex] = state.currentChat;
        return { ...state, chatHistory: updatedChatHistory };
      } else {
        return {
          ...state,
          chatHistory: [...state.chatHistory, action.payload],
        };
      }
    case "UPDATE_CHAT_TITLE":
      if (!state.chatHistory) {
        return { ...state, chatHistory: [] };
      }
      let updatedChats = state.chatHistory.map((chat) => {
        if (chat.id === action.payload.id) {
          if (state.currentChat?.id === action.payload.id) {
            state.currentChat.title = action.payload.title;
          }

          return { ...chat, title: action.payload.title };
        }
        return chat;
      });
      return { ...state, chatHistory: updatedChats };
    case "DELETE_CHAT_ENTRY":
      if (!state.chatHistory) {
        return { ...state, chatHistory: [] };
      }
      let filteredChat = state.chatHistory.filter(
        (chat) => chat.id !== action.payload
      );
      state.currentChat = null;

      return { ...state, chatHistory: filteredChat };
    case "DELETE_CHAT_HISTORY":
      return {
        ...state,
        chatHistory: [],
        filteredChatHistory: [],
        currentChat: null,
      };
    case "DELETE_CURRENT_CHAT_MESSAGES":
      if (!state.currentChat || !state.chatHistory) {
        return state;
      }
      const updatedCurrentChat = {
        ...state.currentChat,
        messages: [],
      };
      return {
        ...state,
        currentChat: updatedCurrentChat,
      };
    case "FETCH_CHAT_HISTORY":
      return { ...state, chatHistory: action.payload };
    case "SET_COSMOSDB_STATUS":
      return { ...state, isCosmosDBAvailable: action.payload };
    default:
      return state;
  }
};
